import { useAuth } from '@/auth/AuthContext'

// Phased rollout для модуля «Витрина»:
// Phase 1 (2026-06-19): только основатель — внутренний дев-релиз
// Phase 2 (2026-06-23): расширенная beta — 4 владельца по 5 каналов
// Wave 2 (2026-06-24): +4 владельца — Showcase-beta-2026-06-24-wave2
// Phase 3: убираем gate целиком (везде true, удалим этот файл)
const SHOWCASE_WHITELIST: string[] = [
  // Phase 1
  '8931841',   // Виктор
  // Phase 2 (2026-06-23)
  '2713777',   // Борис · «Несносный дед PRO», «Найдем дешевле», channel_FreeWork, channel_Yandex_Ads
  '137523760', // «ИИ на службе у бизнеса»
  '255739941', // «МАСЛЕВСКИЙ.РФ ⏐ Недвижимость Краснодара»
  '37365671',  // «Клиенты из MAX ⏐ Ажаж Дмитрий»
  // Wave 2 (2026-06-24)
  '41594480',  // Дима Федоров · «Маркетинг на лайте»
  '125450141', // IN-Trip «Круизный вайб»
  '152373763', // MAX | Захват рынка
  '154088365', // Александр Горлин · Woodnext (private)
]

/**
 * Видно ли пункт меню «Витрина» и доступны ли роуты /showcase/*.
 * Используется в DesktopShell для скрытия пункта меню и в App.tsx
 * как guard на роутах (редирект на /dashboard если не в whitelist).
 */
export function useShowcaseAccess(): boolean {
  const { user } = useAuth()
  if (!user) return false
  return SHOWCASE_WHITELIST.includes(user.maxAdminID)
}
